import { createReducer, on } from '@ngrx/store';
import { EasyDgdStep, ShippingPaper } from '@hazmatsuite-next/easydgd-lib';
import { StepModel, TransportMode } from '@hazmatsuite-next/ui';
import { initStepperSuccess, loadDataSuccess, setSelectedStep, setTransportModeSuccess } from './easydgd-data.actions';

export interface EasyDgdDataState {
  initialized: boolean;
  transportMode: TransportMode;
  step: EasyDgdStep;
  steps: StepModel<EasyDgdStep>[];
  data: {
    [TransportMode.Road]: ShippingPaper | undefined,
    [TransportMode.Rail]: ShippingPaper | undefined,
    [TransportMode.Sea]: ShippingPaper | undefined,
    [TransportMode.Air]: ShippingPaper | undefined,
  };
}

export const initialState: EasyDgdDataState = {
  initialized: false,
  transportMode: TransportMode.Unknown,
  step: EasyDgdStep.TransportMode,
  steps: [],
  data: {
    [TransportMode.Road]: undefined,
    [TransportMode.Rail]: undefined,
    [TransportMode.Sea]: undefined,
    [TransportMode.Air]: undefined,
  }
};

export const easyDgdDataReducer = createReducer(
  initialState,
  on(initStepperSuccess, (state, { steps }) => ({
    ...state,
    initialized: true,
    steps
  })),
  on(setTransportModeSuccess, (state, { transportMode }) => ({
    ...state,
    transportMode,
    step: EasyDgdStep.GeneralInformation
  })),
  on(loadDataSuccess, (state, { transportMode, data }) => ({
    ...state,
    transportMode,
    data: {
      ...state.data,
      [transportMode]: data
    }
  })),
  on(setSelectedStep, (state, { index }) => ({
    ...state,
    step: index
  })),

);
